/* styles for GenericOverlayElement, a Vaadin component */
:host {
  --overlay-width: fit-content;
  --overlay-height: fit-content;
  --overlay-max-width: 100%;
  --overlay-max-height: 100%;
  --overlay-min-width: none;
  --overlay-min-height: none;
  --overlay-border: 1px solid var(--blue-layout-400-primary);
  --overlay-border-radius: calc(var(--spacer) / 2);
  --overlay-box-shadow: none;
  --overlay-background: var(--white-layout-301-level-0-elevation);
  --overlay-content-color: var(--main-titles-inputs-600);

  left: 0;
  top: calc(var(--spacer) / 2);
  width: fit-content;
  height: fit-content;
  z-index: 9999;
  align-items: stretch;
  margin: 0;
}

[part='overlay'] {
  border-radius: var(--overlay-border-radius);
  box-shadow: var(--overlay-box-shadow);
  border: var(--overlay-border);
  flex-direction: column;
  background: var(--overlay-background);
}

[part='content'] {
  padding: 0;
  width: var(--overlay-width);
  height: var(--overlay-height);
  max-width: var(--overlay-max-width);
  max-height: var(--overlay-max-height);
  min-width: var(--overlay-min-width);
  min-height: var(--overlay-min-height);
  color: var(--overlay-content-color);
}
